import Slider from "react-slick"

import { Img } from "../../../../layout/Img"

export const TestimonialColumns = ({ testimonials }) => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 11000,
    speed: 1200,
    initialSlide: 1,
    draggable: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
        },
      },
    ],
  }

  return (
    <div className="container flex items-center justify-center mx-auto">
      <Slider className="w-11/12 lg:w-9/12 customSlick" {...settings}>
        {testimonials.map((item) => (
          <div key={item.uid}>
            <div className="flex flex-col md:flex">
              <div className="flex justify-center mx-auto text-left items-justify">
                <Img
                  className="w-48 h-48 mx-auto my-12 rounded-full"
                  image={item.profilePicture[0]}
                  
                  imgStyle={{ borderRadius: '100%' }}
                />
              </div>

              <div className="items-center justify-center pt-6 text-center md:mx-20 items-justify md:pt-0">
                <div
                  className="text-xl font-normal text-center text-secondary"
                  dangerouslySetInnerHTML={{ __html: item.quote }}
                />

                <p className="pt-4 mx-auto font-light text-center">
                  {`${item.title}, ${item.profileRole}`}
                </p>
                <p className="pt-2 mx-auto font-semibold text-center text-pink">
                  - {item.sponsor[0].title}
                </p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  )
}
